<template>
    <aside class="settings-sidebar">
        <h2 class="sidebar-title">{{ sidebarTitle }}</h2>
        <ul class="menu-list">
            <li class="menu-item" v-for="(menu, index) in processedMenuList" :key="index">
                <div
                    class="menu-link parent-menu"
                    :class="{ 'selected': menu.key === selectedParentMenu }"
                    @click="toggleMenu(index)"
                >
                    <span v-if="menu.icon" class="menu-icon">{{ menu.icon }}</span>
                    <img v-else :src="menu.key === selectedParentMenu ? menu.iconActiveImg : menu.iconimage" alt="" style="width: 20px; height: 20px;"/>
                    <span style="font-size: 1rem;">{{ menu.title }}</span>
                    <div class="toggle-btn">{{ menu.expanded ? '-' : '+' }}</div>
                </div>

                <!-- 二级菜单 -->
                <ul class="submenu" v-show="menu.expanded && menu.children && menu.children.length">
                    <li class="submenu-item" v-for="(child, i) in menu.children" :key="i">
                        <a
                            :href="`#${child.key}`"
                            class="submenu-link"
                            :class="{ active: activeMenu === child.key }"
                            @click.prevent="handleChildClick(child.key, menu.key)"
                        >
                            <span v-if="child.icon"  class="menu-icon">{{ child.icon }}</span>
                            <img v-else :src="activeMenu === child.key ? child.iconActiveImg : child.iconimage" alt="" style="width: 20px; height: 20px;"/>
                            <span>{{ child.title }}</span>
                        </a>
                    </li>
                </ul>
            </li>
        </ul>
    </aside>
</template>

<script>
export default {
    name: 'SidebarMenu',
    props: {
        menuList: {
            type: Array,
            required: true,
            default: () => []
        },
        activeMenu: {
            type: String,
            default: 'rain-well' // 接收父组件传递的默认值（雨水井）
        },
        sidebarTitle: {
            type: String,
            default: '系统设置'
        }
    },
    data() {
        return {
            expandedMenus: [],
            selectedParentMenu: ''
        };
    },
    computed: {
        processedMenuList() {
            return this.menuList.map((menu, index) => ({
                ...menu,
                expanded: this.expandedMenus[index] || false
            }));
        }
    },
    watch: {
        menuList: {
            immediate: true,
            handler(newList) {
                this.expandedMenus = newList.map((_, index) => index === 0);
                this.setDefaultParentMenu();
            }
        },
        activeMenu: {
            immediate: true,
            handler(newKey) {
                console.log("newKey:::",newKey)
                this.setDefaultParentMenu();
            }
        }
    },
    methods: {
        // 新增：设置默认选中的一级菜单（管网资产）
        setDefaultParentMenu() {
            for (const parent of this.menuList) {
                const hasChild = parent.children?.some(c => c.key === this.activeMenu);
                if (hasChild) {
                    this.selectedParentMenu = parent.key;
                    break;
                }
            }
        },
        toggleMenu(index) {
            const newExpandedMenus = [...this.expandedMenus];
            newExpandedMenus[index] = !newExpandedMenus[index];
            this.expandedMenus = newExpandedMenus;
        },
        handleChildClick(menuKey, parentKey) {
            this.$emit('menu-click', menuKey);
            this.selectedParentMenu = parentKey;
            this.expandedMenus[this.menuList.findIndex(m => m.key === parentKey)] = true;
        },
        closeAllMenu() {
            this.expandedMenus = this.expandedMenus.map(() => false);
            this.selectedParentMenu = '';
            this.$emit('close-all-menu');
        }
    },
    mounted() {
        this.expandedMenus = this.menuList.map((_, index) => index === 0);
        this.setDefaultParentMenu(); // 挂载时执行默认选中逻辑
    }
};
</script>
<style scoped>
/* 样式保持不变 */
.settings-sidebar {
    width: 280px;
    background: rgba(20, 35, 70, 0.5);
    border: 1px solid rgba(0, 255, 150, 0.2);
    border-radius: 16px;
    padding: 1.5rem;
    height: fit-content;
    position: sticky;
    top: 100px;
}

.sidebar-title {
    font-size: 1.1rem;
    color: #00ff96;
    margin-bottom: 1.5rem;
}

.menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.menu-item {
    margin-bottom: 0.5rem;
    list-style: none;
}

.parent-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    color: #94a3b8;
    text-decoration: none;
    border-radius: 8px;
    transition: all 0.3s ease;
    cursor: pointer;
}

.parent-menu.selected {
    color: #fff;
    background: rgba(0, 255, 150, 0.6);
}

.parent-menu:hover {
    background: rgba(0, 255, 150, 0.1);
    color: #00ff96;
}

.toggle-btn {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #adadad;
}

.submenu {
    list-style: none;
    padding: 0 0 0 2.5rem;
    margin: 0;
    margin-top: 0.2rem;
}

.submenu-item {
    margin-bottom: 0.25rem;
}

.submenu-link {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 1rem;
    color: #94a3b8;
    text-decoration: none;
    border-radius: 8px;
    transition: all 0.3s ease;
    font-size: 0.9rem;
}

.submenu-link:hover {
    background: rgba(0, 178, 255, 0.1);
    color: #0095ff;
}

.submenu-link.active {
    background: rgba(0, 178, 255, 0.6);
    color: #fff;
    border-left: 3px solid #a7e0ff;
}

.menu-icon {
    font-size: 1.2rem;
}
</style>